import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { TbUserScan } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { IHotelClinicPassengerType } from "@/models/hotel-clinic.model";
import { ClinicArrivalPassengerTypeColumnCell } from "@/pages/HotelPlanning/clinic-arrival/components/unAssignedPassengersTable/ClinicArrivalPassengerTypeColumn";
import { IHotelPlanningDepartureResponseItem } from "@/schemas/hotelPlanningDepartureSchema";

/**
 * Clinic (checkpoint-svc) vs transfer-request (transport-svc) source of a departure row.
 * Reuses the clinic-arrival chip — the row `type` values match `IHotelClinicPassengerType`.
 */
export const HotelDeparturePassengerTypeColumn = ({
    t,
}: {
    t: TFunction;
}): GridColDef<IHotelPlanningDepartureResponseItem> => {
    return {
        field: "type",
        headerName: t("passengerType"),
        minWidth: 140,
        valueGetter: (_val, row) => row.type,
        renderHeader: (params) => <TableHeader Component={TbUserScan} title={params.colDef.headerName!} />,
        renderCell: ({ value }) => <ClinicArrivalPassengerTypeColumnCell value={value as IHotelClinicPassengerType} />,
    };
};

export default HotelDeparturePassengerTypeColumn;
